class RecommendedProducts extends HTMLElement {
  constructor() {
    super();

    this.productId = this.dataset.productId;
    this.limit = this.dataset.limit;
    this.grid = this.querySelector('.grid');
    this.fetchProducts();
  }

  fetchProducts() {
    fetch(`${routes.product_recommendations_url}?product_id=${this.productId}&section_id=related-products&limit=${this.limit}`)
      .then(response => response.text())
      .then(html => {
        this.render(html);
      });
  }

  render(html) {
    let doc = new DOMParser().parseFromString(html, 'text/html');
    let grid = doc.querySelector('.grid');
    this.grid.replaceWith(grid);
  }
}

customElements.define('recommended-products', RecommendedProducts);